module.exports = __webpack_public_path__ + "img/smap4.59bfb92a.png";